import { z } from 'zod'
import {
  trainerOpsDataQualityStatusSchema,
  TRAINER_OPS_READ_CONTRACT_VERSION,
} from './trainer-ops-read'

const trainerDataQualityWriteSideEffectsSchema = z.object({
  db1Written: z.literal(true),
  auditWritten: z.boolean(),
  providerTouched: z.literal(false),
  billingTouched: z.literal(false),
  eventEmitted: z.literal(false),
  uploadTouched: z.literal(false),
  llmTouched: z.literal(false),
  queuePublished: z.literal(false),
  db2Touched: z.literal(false),
}).passthrough()

export const trainerDataQualityUpdateResponseSchema = z.object({
  contract_version: z.literal(TRAINER_OPS_READ_CONTRACT_VERSION),
  exception: z.object({
    key: z.string().min(1),
    status: trainerOpsDataQualityStatusSchema,
    ownerUserId: z.string().nullable(),
    notes: z.string().nullable(),
    updatedAt: z.string().min(1),
  }).passthrough(),
  idempotentReplay: z.boolean(),
  sideEffects: trainerDataQualityWriteSideEffectsSchema,
}).passthrough()

export type TrainerDataQualityUpdateResponse = z.infer<typeof trainerDataQualityUpdateResponseSchema>
export type TrainerDataQualityWriteStatus = z.infer<typeof trainerOpsDataQualityStatusSchema>
